module.exports = __webpack_public_path__ + "img/sign_230290669_1.8365b2d9.png";